import { createElement, useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import {
  McpOauthConnectionsCard,
  McpSetupCard,
  PersonalAccessTokensCard,
} from '../components'
import { usePageLayout } from '@/hooks/usePageLayout'
import SettingsSidebar from '@/components/app/sidebars/settings'
import {
  SettingsPageContainer,
  SettingsPageHeader,
} from '@/components/app/layout'

export default function IntegrationsSettingsPage() {
  const { t } = useTranslation('settings')
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 30_000, retry: 1 },
          mutations: { retry: 0 },
        },
      }),
  )
  usePageLayout({
    sidebarContent: createElement(SettingsSidebar),
    showHeader: false,
  })

  return (
    <QueryClientProvider client={queryClient}>
      <SettingsPageContainer innerClassName="space-y-6">
        <SettingsPageHeader
          title={t('integrationsPage.title')}
          description={t('integrationsPage.subtitle')}
        />
        <McpSetupCard />
        <McpOauthConnectionsCard />
        <PersonalAccessTokensCard />
      </SettingsPageContainer>
    </QueryClientProvider>
  )
}

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/settings/integrations',
)({
  component: IntegrationsSettingsPage,
})
